import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import "reflect-metadata";
import React from 'react';
import { createRoot } from 'react-dom/client';
import TripPlannerApp from "./planner/TripPlannerApp";

const root = createRoot(document.getElementById("tripgo-planner")!);
root.render(<TripPlannerApp apiKey={window.location.hostname.startsWith("chym-beta") ? "032de02a53a155f901e6953bcdbf77ad" : "f1c2e2bc7de12f6659a224a625ec64f3"} />);